/**
 * Chiavi i18n restituite dal backend (ApiError.message / ApiResponse.message) quando un numero
 * di telefono appartiene a una clinica (ClinicPhoneRegistry lato BE).
 */
export const PHONE_BELONGS_TO_CLINIC = 'errors.phoneBelongsToClinic';
export const CLINIC_PHONE_TAKEN = 'errors.clinicPhoneTaken';
export const CLINIC_WHATSAPP_TAKEN = 'errors.clinicWhatsappTaken';

/**
 * Errori gestiti dai componenti con un messaggio tradotto (inline sul campo): l'interceptor non
 * deve mostrare anche il toast generico con la chiave grezza.
 */
export const COMPONENT_HANDLED_ERROR_KEYS: readonly string[] = [
  PHONE_BELONGS_TO_CLINIC,
  CLINIC_PHONE_TAKEN,
  CLINIC_WHATSAPP_TAKEN,
];

function errorMessage(error: any): string | undefined {
  return error?.error?.message;
}

/** Area pubblica: richiesta/recensione fatta con il numero di una clinica (HTTP 422). */
export function isPhoneBelongsToClinicError(error: any): boolean {
  return error?.status === 422 && errorMessage(error) === PHONE_BELONGS_TO_CLINIC;
}

export function isComponentHandledError(error: any): boolean {
  const message = errorMessage(error);
  return !!message && COMPONENT_HANDLED_ERROR_KEYS.includes(message);
}
